import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { Pagination } from 'antd'
import AssessmentRibbon from './ribbon'
import AssessmentDetail from './detail'

export default function Assessment() {
  const merchantOid = localStorage.getItem('merchant_oid')
  const [currentPage, setCurrentPage] = useState(1)
  const [assessmentData, setAssessmentData] = useState({})
  const [isDetailVisible, setIsDetailVisible] = useState(false)
  const [propsData, setPropsData] = useState({})

  const initialConditions = {
    keywords: ''
  }
  const [filterValue, setFilterValue] = useState(initialConditions)

  const getAssessmentData = () => {
    axios.post('/p/assessment/record/list/get', { 
      merchant_oid: merchantOid,
      keywords: filterValue.keywords,
      page: currentPage, 
      per_page: 20
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setAssessmentData({
            'total_page': response.data.total_page,
            'current_page': response.data.current_page,
            'total': response.data.total,
            'records': response.data.records
          })
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  useEffect(() => {
    getAssessmentData()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [merchantOid, currentPage, filterValue])

  const previewDetail = (oid) => {
    setIsDetailVisible(true)
    setPropsData({ oid: oid})
  }

  return (
    <div className="public-page">
      <div className="public-container">
        <div className="public-header">
          <div className="public-title">测评记录</div>
          <AssessmentRibbon 
            filterValue={filterValue} 
            setFilterValue={setFilterValue}
          />
        </div>

        <div className='public-main-style2'>
          <table className='public-main-style2-item'>
            <thead>
              <tr className='public-main-style2-thead'>
                <th style={{textAlign: 'left', paddingLeft: '20px'}}>姓名</th>
                <th>测试项目</th>
                <th>测试结果</th>
                <th>测评时间</th>
              </tr>
            </thead>

            <tbody>
              {assessmentData.records && (assessmentData.records.length > 0 ? (assessmentData.records.map((item) => (
                <tr className='public-main-style2-tbody' key={item.oid} onClick={() => { previewDetail(item.oid) }}>
                  <td style={{textAlign: 'left', paddingLeft: '20px'}}>{item.name || '匿名用户'}</td>
                  <td>{item.assessment_name}</td>
                  <td>{item.result}</td>
                  <td>{item.create_time}</td>
                </tr>
              ))) : (
                <tr className='public-main-style2-tbodyEmpty'>
                  <td colSpan="8"><span>暂无数据</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className='pagination'>
          <Pagination 
            current={currentPage}
            total={assessmentData.total}
            pageSize={20}
            onChange={(page) => setCurrentPage(page)}
            showTotal={(total) => `共${total}条`}
            showSizeChanger={false}
            hideOnSinglePage={true}
            showQuickJumper={true}
          />
        </div>
      </div>

      {isDetailVisible && <AssessmentDetail
        data={propsData}
        isOpen={isDetailVisible}
        isCancel={() => { setIsDetailVisible(false) }}
      />}
    </div>
  )
}
